var searchHandleBarsTemplate = null;
var itemsPerPage = 30;
var SearchType = "";
var initialSearch = true;
var searchParams = null;

function initHandleBarsHelpers() {
    Handlebars.registerHelper("formatDate", function (datetime, format) {
        if (moment) {
            //format = DateFormats[format] || format;
            return moment(datetime).format(format);
        } else {
            return datetime;
        }
    });

    Handlebars.registerHelper('if_eq', function (a, b, opts) {
        if (a === b) {
            return opts.fn(this);
        } else {
            return opts.inverse(this);
        }
    });
}

// Expose globally — called from inline scripts in views and from other modules
window.initHandleBarsHelpers = initHandleBarsHelpers;
window.initSiteSearchHandleBars = initSiteSearchHandleBars;
window.initNewsHandleBars = initNewsHandleBars;
window.DoAjaxSearch = DoAjaxSearch;
window.GetSearchResults = GetSearchResults;
window.clearSiteSearch = clearSiteSearch;
window.clearNewsSearch = clearNewsSearch;
window.clearPublicationSearch = clearPublicationSearch;
window.changeFilterText = changeFilterText;

// Init - Called from the script Utils.AddScript() tag in the template
function initSiteSearchHandleBars(hasSearchTerm, _itemsPerPage) {
    $('#search__results').html("<p><i>Loading..</i></p>");

    if (_itemsPerPage !== undefined && _itemsPerPage !== null && parseInt(_itemsPerPage) > 0) {
        itemsPerPage = parseInt(_itemsPerPage);
    }

    SearchType = "SiteSearch";
    initHandleBarsHelpers();

    var source = document.getElementById("searchTemplate").innerHTML;
    searchHandleBarsTemplate = Handlebars.compile(source);

    if (hasSearchTerm === true) {
        initialSearch = false;  // Prevent a keyword from the query string from being overwritten

        // If we have a search term, do the search
        var prom = GetSearchResults(1);
        prom.then(function (result) {
            console.log("Search results : %o", result);

            var html = searchHandleBarsTemplate(result);
            $('#search__results').html(html);

            $('#pagination_search').pagination({
                items: result.totalResultCount,
                itemsOnPage: itemsPerPage,
                cssStyle: 'light-theme',
                onPageClick: function (pageNumber, event) {
                    DoAjaxSearch(pageNumber);
                    scrollToAnchorIDOffset('topOfSearch');
                },
                onInit: function () {
                    console.log('Init paging');
                    var resultCount = 0;
                    if (result.totalResultCount !== null) {
                        resultCount = result.totalResultCount;
                    }
                    doPagination(resultCount, 1);
                }
            });
        });
    } else {
        // No search term, so just show "No results found"
        $('#search__results').html("<p>No results found</p>");
        $('#pagination_search').html('');
    }

    // Bind event listeners (no change here)
    $('#searchboxSite').keypress(function (event) {
        var keycode = event.keyCode ? event.keyCode : event.which;
        if (keycode === '13') {
            DoAjaxSearch(1);
        }
    });

    $(".search__aggregation input[type='checkbox']").click(function () {
        DoAjaxSearch(1);
    });

    document.getElementById("searchboxSite").addEventListener("search", function (event) {
        DoAjaxSearch(1);
    });
}

// Clear news filters

$("#clearNewsFilters").click(function () {
    event.preventDefault();
    clearNewsSearch();
    //   $(this).html("No filters selected")
    $("#clearNewsFilters").css("display", "none");
    $("#noFiltersSelected").css("display", "block");
    //  $(".search__aggregation-icon").removeClass("search__aggregation-icon--active");
});
function initNewsHandleBars(newsRoot) {
    //newsRootId = newsRoot;
    SearchType = "NewsSearch";
    initHandleBarsHelpers();

    if ($('#resultsPerPage').val() !== '') {
        itemsPerPage = $('#resultsPerPage').val();
    }

    // Init date range picker
    //$('#dateRangePicker').datepicker({
    //    language: 'en',
    //    range: true,
    //    dateFormat: 'M yyyy',
    //    multipleDatesSeparator: " - ",
    //    autoClose: true,
    //    view: "months",
    //    minView: "months",
    //    onSelect: function (formattedDate, date, inst) {
    //        //console.log('on select : %o, %o, %o', formattedDate, date, inst);
    //        if (date.length > 1) {
    //            //"YYYYMMDDHHmmssSSS"
    //            var startString = moment(date[0]).format();
    //            // Only picking month so go to the end of both the days (month) and hours (days)
    //            var endString = moment(date[1]).endOf('month').endOf('day').endOf('hour').endOf('minute').endOf('second').format();
    //            //console.log('Got dates : %o, %o', startString , endString );

    //            $('#startDate').val(startString);
    //            $('#endDate').val(endString);

    //            // Fire the search
    //            if (!initialSearch) {
    //                var datepicker = $('#dateRangePicker').datepicker().data('datepicker');
    //                datepicker.hide();
    //                DoAjaxSearch(1);
    //            }
    //        }
    //    }
    //});
    //$("#dateRangePicker").attr("autocomplete", "off");

    // Init handlebars and get the results
    var source = document.getElementById("searchTemplate").innerHTML;
    searchHandleBarsTemplate = Handlebars.compile(source);
    var prom = GetSearchResults(1, newsRoot);
    prom.then(
        function (result) {
            console.log("Search results : %o", result);

            if (result.results && result.results.length) {
                result.results.sort((a, b) => new Date(b.displayDate) - new Date(a.displayDate));
            }

            var html = searchHandleBarsTemplate(result);
            $('#search__results').html(html);

            $('#pagination_search').pagination({
                items: result.totalResultCount,
                itemsOnPage: itemsPerPage,
                cssStyle: 'light-theme',
                onPageClick: function (pageNumber, event) {
                    //console.log('page %o, contents : %o', pageNumber, event);
                    DoAjaxSearch(pageNumber);
                    scrollToAnchorIDOffset('topOfSearch'); ('topOfSearch');
                },
                onInit: function () {
                    console.log('Init paging');
                    var resultCount = 0;
                    if (result.totalResultCount !== null) {
                        resultCount = result.totalResultCount;
                    }
                    console.log('resultCount : %o', resultCount);

                    doPagination(resultCount, 1);
                }
            });
        }
    );

    // Catch enter key on search box
    $('#searchboxSite').keypress(function (event) {
        var keycode = event.keyCode ? event.keyCode : event.which;
        if (keycode === '13') {
            DoAjaxSearch(1);
        }
    });

    if (document.getElementById("searchboxSite") !== null) {
        document.getElementById("searchboxSite").addEventListener("search", function (event) {
            DoAjaxSearch(1);
        });
    }

    $(".search__aggregation input[type='checkbox']").click(function () {
        changeFilterText();
        DoAjaxSearch(1);
    });
}

function changeFilterText() {
    var filters = $(".search__aggregation input[type='checkbox']:checked");
    if (filters.length > 0) {
        $("#clearNewsFilters").css("display", "block");
        $("#noFiltersSelected").css("display", "none");
    }
    else {
        $("#clearNewsFilters").css("display", "none");
        $("#noFiltersSelected").css("display", "block");
    }
}

function clearPublicationSearch() {
    $('.search__aggregation input[type=checkbox]').prop('checked', '');

    var datepicker = $('#dateRangePicker').datepicker().data('datepicker');

    datepicker.clear();
    $('#startDate').val('');
    $('#endDate').val('');

    DoAjaxSearch(1);
}
function clearNewsSearch() {
    //  var datepicker = $('#dateRangePicker').datepicker().data('datepicker');
    //  datepicker.clear();
    //  $('#startDate').val('');
    //  $('#endDate').val('');

    // $('#searchboxSite').val('');

    $('.search__aggregation input[type=checkbox]').prop('checked', '');
    $('.search__aggregation-icon').removeClass('search__aggregation-icon--active');

    DoAjaxSearch(1);
}
function clearSiteSearch() {
    // Uncheck all the boxes
    $('.search__aggregation input[type=checkbox]').prop('checked', '');
    $('.search__aggregation-icon').removeClass('search__aggregation-icon--active');

    // Recheck the Content type boxes
    $('.search__aggregation input[type=checkbox][data-group="ContentType"]').prop('checked', 'checked');

    DoAjaxSearch(1);
}

// The following groups are called by convention using searchType  e.g. 'populate' + SearchType + '()'
function populatePublicationSearch(fieldsObj) {
    console.log('Populate form from cookie object : %o', fieldsObj);
    $('#searchboxSite').val(fieldsObj.keywords);

    if (typeof fieldsObj["startDate"] !== 'undefined' && typeof fieldsObj["endDate"] !== undefined) {
        var datepicker = $('#dateRangePicker').datepicker().data('datepicker');
        var dates = [moment(fieldsObj.startDate).toDate(), moment(fieldsObj.endDate).toDate()];
        //console.log(dates);
        datepicker.selectDate(dates);
    }

    checkBoxesByValue(fieldsObj.publicationType);
}
function populateNewsSearch(fieldsObj) {
    console.log('Populate form from cookie object : %o', fieldsObj);
    $('#searchboxSite').val(fieldsObj.keywords);

    if (typeof fieldsObj["startDate"] !== 'undefined' && typeof fieldsObj["endDate"] !== undefined) {
        var datepicker = $('#dateRangePicker').datepicker().data('datepicker');
        var dates = [moment(fieldsObj.startDate).toDate(), moment(fieldsObj.endDate).toDate()];
        //console.log(dates);
        datepicker.selectDate(dates);
    }
}
function populateSiteSearch(fieldsObj) {
    console.log('Populate form from cookie object : %o', fieldsObj);
    $('#searchboxSite').val(fieldsObj.keywords);

    // Checked by default so in this case we need to disable all then apply the saved ones
    $('input[type=checkbox][data-group="ContentType"]').prop('checked', '');
    checkBoxesByValue(fieldsObj.contentType);

    checkBoxesByValue(fieldsObj.audience);
    checkBoxesByValue(fieldsObj.health);
    checkBoxesByValue(fieldsObj.services);
}

// Takes an array of values and checks the corresponding boxes
function checkBoxesByValue(arrayOfValues) {
    if (typeof arrayOfValues !== 'undefined') {
        if (arrayOfValues.length > 0) {
            for (var i = 0; i < arrayOfValues.length; i++) {
                $('input[type=checkbox][value="' + arrayOfValues[i] + '"]').prop('checked', 'checked');
            }
        }
    }
}
// Some boxes are ticked by default and we need to untick
function uncheckBoxesByValue(arrayOfValues) {
    if (typeof arrayOfValues !== 'undefined') {
        if (arrayOfValues.length > 0) {
            for (var i = 0; i < arrayOfValues.length; i++) {
                $('input[type=checkbox][value="' + arrayOfValues[i] + '"]').prop('checked', 'checked');
            }
        }
    }
}

function doPagination(resultCount, currentPage) {
    var $pagination = $('#pagination_search');

    console.log('Page results count : %o - Per page : %o', resultCount, itemsPerPage);

    if (resultCount !== null && resultCount > itemsPerPage) {
        $pagination.pagination('destroy');
        $pagination.pagination('updateItems', resultCount);
        $pagination.pagination('drawPage', currentPage);
        $pagination.show();
    } else {
        $pagination.hide();
    }
}

function DoAjaxSearch(pageNo) {
    var $searchBox = $('#searchboxSite');
    if ($searchBox.length === 0) {
        console.warn("Search box not found");
    } else {
        var searchTerm = $searchBox.val().trim();

        if (searchTerm === "") {
            $('#search__results').html("<p>No results found</p>");
            $('#pagination_search').html("");
            scrollToAnchorIDOffset('topOfSearch');
            return;
        }
    }


    var prom = GetSearchResults(pageNo);
    prom.then(
        function (result) {
            console.log("Processing ajax results : %o", result);

            var html = searchHandleBarsTemplate(result);
            $('#search__results').html(html);

            doPagination(result.totalResultCount, pageNo);

            // Order by drop down
            var selector = '#orderField option[value=' + searchParams.orderField + ']';
            $(selector).attr('selected', 'selected');

            scrollToAnchorIDOffset('topOfSearch');
        }
    );
}

// Do our ajax call to fetch the results
function GetSearchResults(pageNo, rootNode) {
    return new Promise(function (resolve, reject) {
        //var searchParams = null;
        var paramSource = "";

        // If we have a cookie use that object to search and populate the form
        if (initialSearch === "disabled" && Cookies.get(SearchType)) {
            // Get from cookie
            paramSource = "cookie";
            searchParams = JSON.parse(Cookies.get(SearchType));
            // default
            searchParams.rootNodeId = rootNode;
            var fn = window['populate' + SearchType];
            if (typeof fn === "function") {
                fn(searchParams);
            } else {
                console.error('Missing populate function %o so can\'t populate form', 'populate' + SearchType);
            }
        } else {
            // Default
            paramSource = "fields";
            searchParams = buildSiteSearchParams(pageNo);
        }

        console.log('GetSearchResults from %o searchParams : %o', paramSource, searchParams);
        initialSearch = false;
        if (searchParams.keywords == null) {
            searchParams.keywords = $('#searchTerm').val();
        }
        $.ajax({
            url: "/Umbraco/Surface/SiteSearch/DoSiteSearchJSON",
            method: 'GET',
            traditional: true,
            data: searchParams
        }).done(function (result) {
            //console.log('done ', result);
            resolve(result);
        }).fail(function (result) {
            console.log('Failed', result);
            reject(result);
        });
    });
}

function filterToArray(collection) {
    var result = new Array();
    var length = collection.length;

    for (var j = 0; j < length; j++) {
        result.push($(collection[j]).val());
    }
    return result;
}

function isEmptyOrSpaces(str) {
    if (str === undefined) { return true; }
    return str === null || str.match(/^ *$/) !== null;
}

function buildSiteSearchParams(pageNo) {
    searchParams = {};
    searchParams.resultPage = pageNo;
    // Keywords
    if ($('#searchboxSite').val() !== '') {
        searchParams.keywords = $('#searchboxSite').val();
    }

    // Specific doc type(s) - Can be used to create a news or event only listing
    if ($('#searchSpecificDocType').val() !== '') {
        searchParams.searchSpecificDocType = $('#searchSpecificDocType').val();
    }

    // content type : "content" or "media"  - (empty = both)
    if ($('#searchContentType').val() !== null && $('#searchContentType').val() !== '') {
        searchParams.contentTypeCorM = $('#searchContentType').val();
    }

    // Root node restriction . e.g. publications only look in the archive folder
    var rnv = $('#rootNode').val();
    if (rnv !== null && rnv !== '' && rnv !== undefined) {
        searchParams.rootNodeId = $('#rootNode').val();
    }

    // Date filter target field
    if ($('#dateFilterField').val() !== null && $('#dateFilterField').val() !== '') {
        searchParams.dateFilterField = $('#dateFilterField').val();
    }

    // Results order
    if ($('#orderField').val() !== null && $('#orderField').val() !== '') {
        searchParams.orderField = $('#orderField').val();
    }

    // Results per page
    if ($('#resultsPerPage').val() !== null && $('#resultsPerPage').val() !== '') {
        searchParams.resultsPerPage = $('#resultsPerPage').val();
    }

    /// =================================
    /// Custom taxonomy
    /// =================================

    // Services Area
    var checks = $("input[type='checkbox']:checked[data-group='Area']");
    if (checks.length) {
        searchParams.area = filterToArray(checks);
        console.log(searchParams.area);
    }

    // Services
    checks = $("input[type='checkbox']:checked[data-group='Services']");
    if (checks.length) {
        searchParams.service = filterToArray(checks);
    }
    // Hopsital/Locations
    checks = $("input[type='checkbox']:checked[data-group='Hospital Locations']");
    if (checks.length) {
        searchParams.hospitals = filterToArray(checks);
    }

    // Health topic
    checks = $("input[type='checkbox']:checked[data-group='Health Topic']");
    if (checks.length) {
        searchParams.health = filterToArray(checks);
    }

    // Audience
    checks = $("input[type='checkbox']:checked[data-group='Audience']");
    if (checks.length) {
        searchParams.audience = filterToArray(checks);
    }

    // Content type
    checks = $("input[type='checkbox']:checked[data-group='ContentType']");
    if (checks.length) {
        searchParams.contentType = filterToArray(checks);
    }

    // Publication Types
    checks = $("input[type='checkbox']:checked[data-group='pubTypes']");
    if (checks.length) {
        searchParams.publicationType = filterToArray(checks);
    }

    // People
    var checks = $("input[type='checkbox']:checked[data-group='people']");
    if (checks.length) {
        searchParams.people = filterToArray(checks);
    }

    if (!isEmptyOrSpaces($('#startDate').val()) && !isEmptyOrSpaces($('#endDate').val())) {
        searchParams.startDate = $('#startDate').val();
        searchParams.endDate = $('#endDate').val();
    }

    // Save a cookie
    if (SearchType === "") {
        console.log('Search type not set so no cookie name available');
    } else {
        console.log('Setting %o cookie to %o', SearchType, searchParams);
        Cookies.set(SearchType, searchParams, {
            //expires: 1 - Session cookie
        });
    }

    return searchParams;
}